import { resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BreadCrumb = _resolveComponent("BreadCrumb")!
  const _component_EducationalSectionsList = _resolveComponent("EducationalSectionsList")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_BreadCrumb, {
      PageParent: "Secciones Educativas",
      PageTitle: "Secciones Educativas",
      parentRoute: "/educ-sections-list"
    }),
    _createVNode(_component_EducationalSectionsList, { axios: _ctx.$axios }, null, 8, ["axios"])
  ], 64))
}